import { render, staticRenderFns } from "./AttachmentSidebar.vue?vue&type=template&id=2d301a70"
import script from "./AttachmentSidebar.vue?vue&type=script&lang=js"
export * from "./AttachmentSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports